import React from "react";
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {PeriodCalendar} from "../groups/group-container/main-table/period-calendar/Period-calendar";
import {ReactComponent as TableIcon} from '../../../assets/navigate/table.svg';
import {Table} from "./table/Table";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import {useAppSelector} from "common/hook";


export const SummaryTable = () => {
    const summaryTableData = useAppSelector(state => state.summaryTable)
   const {data} = summaryTableData;
    const {page} = data.pagination;

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Сводная таблица'} tabs={false} setting={false} link={'/summary-table'}
                         icons={<TableIcon/>}/>
                <PeriodCalendar create={false} print={true} company={data.company} page={page}/>
                <Table/>
            </div>
        </AuthWrapper>
    );
};

